import Konva from 'konva';
import React, { useMemo } from 'react';
import { Group, Line, Rect } from 'react-konva';
import { Color, DateNumber } from 'types/global';
import { Activity, GraphStyle } from '../types';
import { xFromTimeStyled } from '../utils';



function Histogram({
	start,
	activities,

	style,
	height,
	width,
	...props
}: HistogramProps) {

	// HOOKs
	const xFromTime = xFromTimeStyled(style, start)

	// prendo in considerazione solo l'ultima riga (quella dei totali)
	const datas: HistogramData[] = useMemo(() =>
		activities.reduce((acc, activity) => {
			// se è fuori dalla zona visibile (orizzontale) salta
			const histX = xFromTime(activity.start)
			if (histX < 0 || histX > width) return acc

			// se non c'e' un valore da rappresentare salta
			if (isNaN(activity.value)) return acc

			// calcola l'altezza
			let histH = Math.ceil(activity.value * style.histogram.factor) ?? 0
			if (histH == 0) return acc

			// calcola il colore
			let color = style.histogram.color
			// se supero un certo limite allora cambia colore
			if (histH > height) {
				histH = height
				color = style.histogram.highValueColor
			}

			acc.push({ x: histX, height: histH, color })
			return acc
		}, [] as HistogramData[]),
		[start, activities]
	)

	// RENDER
	if (!activities) return null
	const yMiddle = (height / 2) -2.5

	return (<Group {...props}>

		<Rect 
			x={0} y={0-style.groupMargin} 
			width={width} height={height+style.groupMargin} 
			fill={style.histogram.bgColor} 
		/>

		{datas.map((data, index) => <Rect key={index} listening={false} strokeEnabled={false}
			x={data.x}
			y={-data.height - 2 + height}
			width={style.space.x - 1}
			height={data.height}
			fill={data.color}
		/>)}

		<Line  
			points={[-.5, yMiddle, width, yMiddle]} 
			stroke={style.histogram.lineColor} dash={[5,5]} strokeWidth={1} 
		/>
		
	</Group>)
}

export default Histogram

Histogram.CalcHeight = (props: { style: GraphStyle }) => props.style.histogram.height

type HistogramProps = {
	start: DateNumber,
	activities: Activity[],
	height?: number,
	width?: number,

	style: GraphStyle
} & Konva.NodeConfig


/**
 * Dati per la visualizzazione di un dato per istogramma
 */
type HistogramData = {
	x: number,
	height: number,
	color: Color
}
